import TextWithImage from './TextWithImage';

export default TextWithImage;